import { useTheme } from '../context/ThemeContext';

/**
 * Stavyn logo — auto-switches between dark/light logo based on theme.
 * variant="light" = dark logo for light backgrounds (logo-dark.png)
 * variant="dark"  = white logo for dark backgrounds (logo-light.png)
 * variant="auto"  = follows ThemeContext (default)
 */
export default function Logo({ className = '', variant = 'auto', style = {} }) {
  const { isDark } = useTheme();

  let resolvedVariant = variant;
  if (variant === 'auto') {
    resolvedVariant = isDark ? 'dark' : 'light';
  }

  const src = resolvedVariant === 'dark' ? '/logo-light.png' : '/logo-dark.png';

  return (
    <img
      src={src}
      alt="Stavyn"
      className={`shrink-0 object-contain ${className}`.trim()}
      style={{ display: 'block', verticalAlign: 'middle', ...style }}
    />
  );
}
